import { Injectable } from '@angular/core';
import { Constants } from '../../shared/Constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable()
export class RetentionService {

  constructor(private http: HttpClient) { }

  getAllRetentionHeaders() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.get(Constants.URL_BACKEND + '/retencion-header', { headers: headers });
  }
  getRetentionHeader(id) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.get(Constants.URL_BACKEND + '/retencion-header/' + id, { headers: headers });
  }

  getRetentionHeaderProveedor( proveedor, fechainicio, fechafinal) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/retencion-headerfiltro', { params: { proveedor: proveedor, fechainicio: fechainicio, fechafinal: fechafinal }, headers: headers });
  }

  createRetentionHeader(insertData) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.post(Constants.URL_BACKEND + '/retencion-header', { data: insertData }, { headers: headers });
  }
  updateRetentionHeader(updateData) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.put(Constants.URL_BACKEND + '/retencion-header/' + updateData.id, { data: updateData }, { headers: headers });
  }

  emitRetentionHeader(emit) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.put(Constants.URL_BACKEND + '/retencion-header-emit/' +emit, {  }, { headers: headers });
  }

  voidRetentionHeader(emit) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.put(Constants.URL_BACKEND + '/retencion-header-void/' +emit, {  }, { headers: headers });
  }

  
  deleteRetentionHeader(id) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.delete(Constants.URL_BACKEND + '/retencion-header/' + id, { headers: headers });
  }
  InsertAllDetails(array, RetentionHeaderId) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.put(Constants.URL_BACKEND + '/retencion-detail/all/' + RetentionHeaderId, { data: array }, { headers: headers });
  }
  getRetentionDetails(headerId) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/retencion-detail/retencion-header/' + headerId, { headers: headers });
  }
  getOneDetail(id) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/retencion-detail/' + id, { headers: headers });
  }
  insertBatch(insertData) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.post(Constants.URL_BACKEND + '/retencion-detail/batch', { data: insertData }, { headers: headers });
  }
  sendMail(data,email){
    console.log("data",data);
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.post(Constants.URL_BACKEND + '/sendMailBO', { data: data, email: email }, { headers: headers });

  }

  downloadRetentionList(filters) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set(
      'Authorization',
      'Basic ' + btoa(localStorage.getItem('jwt'))
    );

    const optionArgs = {
      headers: headers,
      responseType: 'blob' as 'json'
    }

    return this.http.post(Constants.URL_BACKEND + '/retencion-header-list/export', filters, optionArgs);
  }

}



// WEBPACK FOOTER //
// ./src/app/system/services/retention.service.ts